import React from "react";
import { Manager, Reference, Popper } from "react-popper";

let rePositionTimeout = null;
let rePositionUpdate = null;
const queueRePosition = () => {
  if (rePositionTimeout) clearTimeout(rePositionTimeout);
  rePositionTimeout = setTimeout(rePositionUpdate, 200);
};

export default (props) => {
  const placement = props.placement || "auto";
  const content = props.content || null;
  const className = props.className || "";
  const isWhite = props.isWhite || false;

  return (
    <Manager>
      <Reference>
        {({ ref }) => (
          <span className={`${className} tooltip-holder`} ref={ref}>
            {props.children}
          </span>
        )}
      </Reference>
      <Popper
        placement={placement}
        eventsEnabled={false}
        modifiers={{
          preventOverflow: {
            enabled: true,
            padding: 10,
            boundariesElement: "scrollParent",
            priority: ["right", "top", "bottom", "left"],
          },
          flip: {
            enabled: false,
          },
          outOfBoundaries: false,
          computeStyle: {
            x: "top",
            y: "right",
          },
        }}
        outOfBoundaries={false}
      >
        {({
          ref,
          style,
          placement,
          arrowProps,
          scheduleUpdate,
          ...otherProps
        }) => {
          rePositionUpdate = scheduleUpdate;
          window.addEventListener("resize", queueRePosition);
          window.addEventListener("scroll", queueRePosition);
          return (
            <div
              ref={ref}
              style={style}
              data-placement={placement}
              className={`tooltip ${isWhite ? "tooltip-white" : ""}`}
            >
              {content}
              <div
                ref={arrowProps.ref}
                style={arrowProps.style}
                className={isWhite ? "tooltip__arrow-white" : "tooltip__arrow"}
              />
            </div>
          );
        }}
      </Popper>
    </Manager>
  );
};



// WEBPACK FOOTER //
// ./src/components/Common/ToolTip.js